import { render, staticRenderFns } from "./Eventi.vue?vue&type=template&id=1462c091&scoped=true&"
import script from "./Eventi.vue?vue&type=script&lang=js&"
export * from "./Eventi.vue?vue&type=script&lang=js&"
import style0 from "./Eventi.vue?vue&type=style&index=0&id=1462c091&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1462c091",
  null
  
)

export default component.exports